module.exports = __webpack_public_path__ + "static/img/cont35 (2).632ef4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (2).jpg
// module id = YPL9
// module chunks = 0